<ul class="workflow-property-list">
    <li ng-repeat="prop in $ctrl.properties track by $index" ng-class="isNew(prop)" title="{{prop.title}}">
        <span ng-bind-html="prop.value|cHighlight:$ctrl.highlight"></span>
    </li>
</ul>